/**
 * @generated SignedSource<<36859e12eb785120370d718f44319354>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_user">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_user";
};
export type PdpRespSidebarBlurbs_user$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "266e941a1550c7153abe9cde0d2a6d6b";

export default node;
